module.exports = __webpack_public_path__ + "img/logo.d2cdd374.png";